module.exports = __webpack_public_path__ + "media/images/reply_mypage-d833ad15e4aca48a3959cc3913b66a68.svg";